import React, { useContext } from "react";
import { Modal, Tabs } from "antd";
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-github";

import { GlobalContext } from "./GlobalContext";

const DataViewer = ({ dataViewerVisible, setDataViewerVisible }) => {
    const { userData } = useContext(GlobalContext);

    const handleOk = () => {
        setDataViewerVisible(false);
    };

    return (
        <>
            <Modal
                title="Data Viewer"
                visible={dataViewerVisible}
                maskClosable={false}
                closable={false}
                okText={"Close"}
                onOk={handleOk}
                cancelButtonProps={{ style: { display: "none" } }}
                width={800}
            >
                <Tabs defaultActiveKey="folder" type="card" tabPosition="left">
                    {userData
                        ? Object.keys(userData).map((key) => {
                              return (
                                  <Tabs.TabPane
                                      tab={`${key}.json`}
                                      key={key}
                                      style={{ padding: `0 5px` }}
                                  >
                                      <AceEditor
                                          readOnly={true}
                                          mode="json"
                                          theme="github"
                                          disabled={true}
                                          name={key}
                                          showPrintMargin={false}
                                          value={JSON.stringify(
                                              userData[key],
                                              null,
                                              2
                                          )}
                                          fontSize={12}
                                          style={{
                                              fontFamily: `"B612 Mono", monospace`,
                                              width: "100%",
                                          }}
                                      />
                                  </Tabs.TabPane>
                              );
                          })
                        : null}
                </Tabs>
            </Modal>
        </>
    );
};

export default DataViewer;
